import window from 'window-or-global';

/**
 * Handling of the Office Connector property panel buttons in the editor.
 * Copied from https://stash.atlassian.com/projects/CONFCLOUD/repos/officeconnector
 * @see /officeconnector/Zen/src/main/resources/javascript/property-panel.js
 */
function registerPropertyPanelButton() {
	window.AJS.Confluence.PropertyPanel.Macro.registerButtonHandler(
		'office-connector-download-file-button',
		(e, macroNode) => {
			//check if macroNode is a jQuery obj
			macroNode = macroNode.nodeType ? macroNode : macroNode[0];
			// read the macro properties from the macro
			const macroParameters = macroNode.getAttribute('data-macro-parameters');

			const paramPairs = macroParameters.split('|');
			const params = {};
			for (let i = 0; i < paramPairs.length; i++) {
				const nameAndValue = paramPairs[i];
				const parts = nameAndValue.split('=');
				if (parts.length > 1) {
					params[parts[0]] = parts[1];
				}
			}

			const pageId = window.AJS.Meta.get('page-id');
			const contextType = window.AJS.Meta.get('content-type');

			// space key is required in the case where the context page is a new draft
			if (!params['space']) {
				params['space'] = window.AJS.Meta.get('space-key');
			}

			function addToUrlIfDefined(name, value, url) {
				if (name && value) {
					if (url.charAt(url.length - 1) != '?') {
						url += '&';
					}

					url = `${url}${name}=${encodeURI(value)}`;
				}

				return url;
			}

			const baseUrl = window.AJS.Meta.get('context-path');
			const servletPath = '/plugins/servlet/oc/getattachment?';
			let url = baseUrl + servletPath;
			url = addToUrlIfDefined('title', params['page'], url);
			url = addToUrlIfDefined('date', params['date'], url);
			url = addToUrlIfDefined('space', params['space'], url);
			url = addToUrlIfDefined('filename', params['name'], url);
			url = addToUrlIfDefined('contextid', pageId, url);
			url = addToUrlIfDefined('contexttype', contextType, url);

			const windowName =
				window.AJS.$.browser && window.AJS.$.browser.msie ? '_blank' : 'download-office-attachment';

			window.open(url, windowName);
		},
	);
}

export function officeConnector() {
	registerPropertyPanelButton();
}
export function officeConnectorWRM() {
	return ['wr!com.atlassian.confluence.editor:property-panel-image-link-macro-conf-frontend'];
}
